import React from "react";
import Link from "next/link";

import Box from "@/components/shared/Box";

import type { EmptyProps } from "./empty.types";

import s from "./empty.module.scss";

const Empty = ({ message, settingsLink }: EmptyProps) => {
  return (
    <Box
      padding="var(--token-spacings-xs)"
      borderRadius="var(--token-border-radius-lg)"
      border="1px solid var(--token-colors-neutral-cloud-normal)"
      gap="var(--token-spacings-sm)"
    >
      <div className={s.content}>
        <div className={`avatar-illustration--address-error ${s.avatar}`} />
        <div className={s.description}>
          <strong className="heading-xs">{message.title}</strong>
          <div>
            <p className="body-text-md">{message.description}</p>
            {message.additionalDescription && (
              <p className="body-text-md">{message.additionalDescription}</p>
            )}
          </div>
        </div>
      </div>
      <div className={s["wrapper-button"]}>
        <Link
          className={`btn btn-md btn-turquoise ${s.button}`}
          onClick={settingsLink.onClick || undefined}
          href={settingsLink.href}
        >
          {settingsLink.label}
        </Link>
      </div>
    </Box>
  );
};

export default Empty;
